/* eslint react/prop-types: 0 */
/* eslint import/no-extraneous-dependencies: 0 */ // Trans is a macro

import { makeStyles } from '@material-ui/core/styles';
import { Trans } from '@lingui/macro';
import { Box } from '@material-ui/core';
import StatusBlock from '../../../status-block/StatusBlock';
import { useStatusFilter } from '../../../filters';

const useStyles = makeStyles((theme) => ({
    root: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.justifyContentCenter,
        ...theme.mixins.flex.alignItemsCenter,
    },
    block: {
        textTransform: 'uppercase',
        fontSize: '12px',
        fontWeight: 500,
        padding: '8px 12px',
        cursor: 'default',
    },
}));

const BlockCount = ({ statusFilter, color, count, desc }) => {
    const classes = useStyles();
    if (!statusFilter[color]) return null;
    return (
        <>
            <StatusBlock color={color} />
            <div className={classes.block}>
                {count} {desc}
            </div>
        </>
    );
};

export default function Summary({ summary, height }) {
    const classes = useStyles();
    const statusFilter = useStatusFilter();
    const counts = summary?.data?.[0]?.statusCounts;
    if (!counts) return <Box height={height} />;
    return (
        <div className={classes.root}>
            <BlockCount
                statusFilter={statusFilter}
                color="red"
                count={counts?.redCount}
                desc={<Trans>Critical</Trans>}
            />
            <BlockCount
                statusFilter={statusFilter}
                color="orange"
                count={counts?.orangeCount}
                desc={<Trans>Excessive</Trans>}
            />
            <BlockCount
                statusFilter={statusFilter}
                color="yellow"
                count={counts?.yellowCount}
                desc={<Trans>Degraded</Trans>}
            />
            <BlockCount
                statusFilter={statusFilter}
                color="green"
                count={counts?.greenCount}
                desc={<Trans>Normal</Trans>}
            />
            <BlockCount
                statusFilter={statusFilter}
                color="gray"
                count={counts?.grayCount}
                desc={<Trans>No Data</Trans>}
            />
        </div>
    );
}
